import { slugify } from './stringParsing.js'

export function getShortName(styleColor) {
  if (!styleColor?.style?.subcategory) return undefined
  if (styleColor.style.subcategory === 'Other') return ''
  if (styleColor.style.subcategory === 'Soft Pants') return ' Casual Pants'
  if (styleColor.style.subcategory === 'Soft Jacket') return ' Jacket'
  if (styleColor.style.subcategory === 'Shirt/Button-up') return ' Button-up'
  return ' ' + styleColor.style.subcategory
}

export function getProfileSizesForStyleColor(styleProfile, styleColor) {
  const sizing = `${styleColor.sizingCategory}Sizes`
  return styleProfile[sizing]
}

export function getBulletWithLinks(bullet) {
  let message = bullet.bullet
  bullet.links.forEach(link => {
    // The 'g' flag ensures all occurrences are replaced.
    // The text is escaped to handle any special characters in the string.
    const regex = new RegExp(link.link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
    const linkHtml = `<a href="${link.url}" target="_blank" rel="noopener noreferrer">${link.link}</a>`
    message = message.replace(regex, linkHtml)
  })
  return message
}

export function detailPageSlug(styleColor) {
  return slugify(`${styleColor.style.brand} ${styleColor.style.name}`)
}

export function isMaternitySize(size) {
  return !size.includes('/') && size.endsWith('M') && size.length > 1
}
